<template>
    <div>
        <button type="button" class="btn btnclass smallerfontsize mr-3 selected" @click="fieldData.showDateModal = true">
            Date
        </button>
        <b-modal id="modal-date" v-model="fieldData.showDateModal" @hide="popupIsHidden" title="Date" @shown="popupIsShown" @ok="saveDate">
            <b-form-row>
                <b-col lg="6" class="pl-2">
                    <label :class="['label-text', fieldData.startDate.hasError ? 'error' : '']">
                        {{ fieldData.startDate.label }}
                    </label>
                    <div :class="['wrapsmallbtns date-presets-mini-buttons']">
                        <b-button @click="clicked1d" v-b-tooltip.hover title="1d: Set start and end date to the latest day with data" variant="primary" class="datefrombtn">1d</b-button>
                        <b-button @click="clicked1v" v-b-tooltip.hover title="1v: Set start date to one week from the latest day with data" variant="primary" class="datefrombtn">1v</b-button>
                        <b-button @click="clickedF1v" v-b-tooltip.hover title="f1v: Set start and end date to the latest complete week with data" variant="primary" class="datefrombtn"
                            >f1v</b-button
                        >
                        <b-button @click="clicked1m" v-b-tooltip.hover title="1m: Set start date to one month from the latest day with data" variant="primary" class="datefrombtn">1m</b-button>
                        <b-button @click="clickedF1m" v-b-tooltip.hover title="f1m: Set start and end date to the latest complete month with data" variant="primary" class="datefrombtn"
                            >f1m</b-button
                        >
                    </div>
                    <DateFromAds
                        :fieldData="fieldData.startDate"
                        :latestDate="$store.getters.getMetadataAdToDate"
                        @onInputChanged="inputChanged"
                        getter="getAdsQuery"
                        setter="setAdsQuery"
                        parentName="ads"
                        mutationSetEnddate="setAdsEnddate"
                        mutationSetStartdate="setAdsStartdate"
                    />
                </b-col>
                <b-col lg="6" class="pr-2">
                    <DateToAds
                        :fieldData="fieldData.endDate"
                        :latestDate="$store.getters.getMetadataAdToDate"
                        getter="getAdsQuery"
                        setter="setAdsQuery"
                        parentName="ads"
                        mutationSetEnddate="setAdsEnddate"
                        mutationSetStartdate="setAdsStartdate"
                    />
                </b-col>
            </b-form-row>
            <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Cancel
                </b-button>
                <b-button size="sm" variant="primary" :disabled="disableRunBtn()" @click="ok()">
                    Save
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import DateFromAds from "@/components/Shared/FormElement/DatePicker/DateFromAds"
import DateToAds from "@/components/Shared/FormElement/DatePicker/DateToAds"
import dayjs from "dayjs"
import propsDate from "@/mixins/inputPropsDate"
import { determineApiVersion } from "../../../api/utils.js"

export default {
    name: "DateModalAd",
    mixins: [propsDate],
    components: {
        DateFromAds,
        DateToAds,
    },
    props: {
        fieldData: {
            type: Object,
            required: true,
        },
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
    },
    watch: {
        async "fieldData.startDate.tempStartDate"() {
            let startDate = this.fieldData.startDate.tempStartDate
            let endDate = this.fieldData.endDate.tempEndDate
            if (!this.isValidDate(endDate) || !this.isValidDate(startDate)) {
                return
            }

            const apiVersion = await determineApiVersion(startDate, "ads")

            if (apiVersion.appVersion === "1" && this.$store.getters.getSSASMessage.linkedSSAS != "total2_analysis_dev") {
                this.$bvModal.show(this.seeOldDataDialogId)
            } else if (startDate > endDate) {
                this.fieldData.endDate.tempEndDate = startDate
            }
        },
        async "fieldData.endDate.tempEndDate"() {
            let startDate = this.fieldData.startDate.tempStartDate
            let endDate = this.fieldData.endDate.tempEndDate

            if (!this.isValidDate(endDate) || !this.isValidDate(startDate)) {
                return
            }

            const apiVersion = await determineApiVersion(startDate, "ads")

            if (apiVersion.appVersion === "1" && this.$store.getters.getSSASMessage.linkedSSAS != "total2_analysis_dev") {
                this.$bvModal.show(this.seeOldDataDialogId)
            } else if (startDate > endDate && endDate) {
                this.fieldData.startDate.tempStartDate = endDate
            }
        },
    },
    methods: {
        disableRunBtn() {
            let disableRunBtn = false
            if (this.fieldData.startDate.hasError || this.fieldData.endDate.hasError) disableRunBtn = true
            return disableRunBtn
        },
        inputChanged(hasError, identifier) {
            this.$emit("onInputChanged", hasError, identifier)
        },
        isValidDate(date) {
            return dayjs(date, "YYYY-MM-DD").format("YYYY-MM-DD") === date
        },
        clicked1d() {
            this.fieldData.startDate.tempStartDate = this.latestDate
            this.fieldData.endDate.tempEndDate = this.latestDate
        },
        clicked1v() {
            let sevenMmsDaysEarlier = dayjs(this.latestDate)
                .subtract(6, "day")
                .format("YYYY-MM-DD")
            this.fieldData.startDate.tempStartDate = sevenMmsDaysEarlier
            this.fieldData.endDate.tempEndDate = this.latestDate
        },
        clickedF1v() {
            let weekday = require("dayjs/plugin/weekday")
            dayjs.extend(weekday)
            let isAdToDateSunday = dayjs(this.latestDate).weekday() == 6
            let monday = dayjs(this.latestDate)
                .weekday(isAdToDateSunday ? 0 : -7)
                .format("YYYY-MM-DD")
            let sunday = dayjs(this.latestDate)
                .weekday(isAdToDateSunday ? 6 : -1)
                .format("YYYY-MM-DD")
            this.fieldData.startDate.tempStartDate = monday
            this.fieldData.endDate.tempEndDate = sunday
        },
        clicked1m() {
            let oneMmsMonthEarlier = dayjs(this.latestDate)
                .subtract(1, "month")
                .add(1, "day")
                .format("YYYY-MM-DD")
            this.fieldData.startDate.tempStartDate = oneMmsMonthEarlier
            this.fieldData.endDate.tempEndDate = this.latestDate
        },
        clickedF1m() {
            let isLastAdToDateLastDayOfMonth = dayjs(this.latestDate).date() == dayjs(this.latestDate).daysInMonth()
            let month = dayjs(this.latestDate).subtract(isLastAdToDateLastDayOfMonth ? 0 : 1, "month")
            let firstDayOfMonth = month.set("date", 1).format("YYYY-MM-DD")
            let lastDateMonth = month.set("date", month.daysInMonth()).format("YYYY-MM-DD")
            this.fieldData.startDate.tempStartDate = firstDayOfMonth
            this.fieldData.endDate.tempEndDate = lastDateMonth
        },
        popupIsShown() {
            document.addEventListener("keyup", this.onKeyUp)
            const query = this.$store.getters.getAdsQuery
            this.fieldData.startDate.tempStartDate = query.startDate
            this.fieldData.endDate.tempEndDate = query.endDate
        },
        popupIsHidden() {
            document.removeEventListener("keyup", this.onKeyUp)
        },
        saveDate() {
            const query = this.$store.getters.getAdsQuery
            query.startDate = this.fieldData.startDate.tempStartDate
            query.endDate = this.fieldData.endDate.tempEndDate
            this.$emit("onGetBuyingAgenciesAdvertisersProducts")
        },
        onKeyUp(event) {
            if (event.key === "Enter" && this.fieldData.showDateModal) {
                this.fieldData.showDateModal = false
                this.saveDate()
            }
        },
    },
}
</script>
<style scoped>
>>> .modal-content {
    width: 35rem;
}
.error {
    color: red;
    transition: color 0.3s;
}
</style>
